import React from 'react';
import { Updater } from 'use-immer';
import { useTranslation } from 'react-i18next';

import Toggle from '@dsc/forms/customInputs/Toggle';
import IncrementStepper from '@dsc/forms/customInputs/IncrementStepper';

import { curriedStateSlice } from '@helpers/state/state.helpers';

import { DialogSettingsState } from '@core/types/Dialogs';

const localNamespace = 'imports.wlWeb.ui.components.card.updateCard';

type DialogFormSettingsProps = {
    hasAdminRole?: boolean;
    state: DialogSettingsState;
    setState: Updater<DialogSettingsState>;
};

const DialogFormSettings = React.forwardRef<HTMLElement, DialogFormSettingsProps>(
    function DialogFormSettings({ hasAdminRole, state, setState }, ref) {
        const { t } = useTranslation();

        const updateSlice = curriedStateSlice(setState);

        return (
            <section className="settings" ref={ref}>
                {hasAdminRole && (
                    <label>
                        {t(`common:${localNamespace}.postBoxUpdateForm.display_order`)}
                        <IncrementStepper
                            value={state.rankOrder}
                            onChange={updateSlice('rankOrder')}
                        />
                    </label>
                )}
                {hasAdminRole && (
                    <label>
                        {t(`common:${localNamespace}.mediaCardUpdateForm.display_in_newsfeed`)}
                        <Toggle
                            value={state.displayInNewsfeed}
                            onChange={updateSlice('displayInNewsfeed')}
                        />
                    </label>
                )}
            </section>
        );
    }
);

export default DialogFormSettings;
